import { FC } from 'react';
import Breadcrumb from '../../components/atoms/Breadcrumb';
import { useNavigate } from 'react-router-dom';
import { IoMdArrowBack } from 'react-icons/io';
import AccessDeniedImage from '../../components/ions/AccessDeniedImage';


const AccessDenied: FC = () => {

	const navigate = useNavigate();

	const items = [{
		label: "Home",
		url: "/"
	}, {
		label: "Acesso negado",
		url: "#"
	}]


	return (
		<div className="flex flex-col h-screen">
			<div className="p-4">
				<Breadcrumb items={items} />
			</div>
			<div className="flex flex-grow items-center justify-center">
				<div className="text-center">
					<div className="flex items-center justify-center">
						<AccessDeniedImage />
						<div>
							<h1 className="text-5xl font-bold text-gray-700">Erro 403!</h1>
							<p className="text-2xl my-4">Acesso Negado!</p>
						</div>
					</div>
					<div className="mx-auto p-4 text-gray-600 text-center">
						<p className="mb-4">
							Você não tem permissão para utilizar este recurso.
							Solicite acesso à chefia imediata.
						</p>
						<p>
							Caso o problema persista, verifique se houve alguma mudança de
							permissão no recurso com a equipe tech através do canal slack
							#agrolend-tech-support
						</p>

						<button
							id='back-button'
							className="mt-4 px-3 py-2 text-xs font-medium text-center inline-flex text-white bg-blue-500 rounded hover:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-offset-white focus:ring-offset-2"
							onClick={() => navigate(-3)}>
							<IoMdArrowBack className='mr-2' />
							Voltar para página anterior
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AccessDenied;
